import BaseAPI from '../base'

function getAll(cafe_id) {
    return BaseAPI.get(`subscription/all/${cafe_id}`);
}

function generateForm(subscription_id, periodicity, changing_card) {
    return BaseAPI.get(`subscription/form/${subscription_id}`, {
        periodicity: periodicity || 'month',
        changing_card: changing_card || undefined
    });
}

function getTransactions(cafe_id) {
    return BaseAPI.get(`subscription/transactions/${cafe_id}`);
}

function cancelSubscription(subscription_id) {
    return BaseAPI.post(`subscription/cancel/${subscription_id}`);
}

function claimRefund(id) {
    return BaseAPI.post(`subscription/claim_refund/${id}`);
}

export default {
  getAll,
  generateForm,
  getTransactions,
  cancelSubscription,
  claimRefund,
};